interface ITelefone {
    ddd: string,
    telefone: string,
    cookie: string
}

export const instanceOfITelefone = (object: any): object is ITelefone => {
    return 'ddd' in object &&
           'telefone' in object &&
           'cookie' in object
}

export default ITelefone